var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_680_13617)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5532 7.60001C11.1331 6.76718 11.9949 6.17248 12.9793 5.92584C13.9637 5.67921 15.0041 5.79734 15.9081 6.25838C16.8121 6.71942 17.5187 7.4922 17.8971 8.43382C18.2755 9.37545 18.3002 10.4222 17.9666 11.3807C17.6329 12.3391 16.9636 13.1443 16.0823 13.6474C15.201 14.1505 14.1673 14.3175 13.1724 14.1176C12.1774 13.9176 11.2886 13.3642 10.6701 12.5596C10.0516 11.755 9.74539 10.7537 9.808 9.74081C9.81109 9.69802 9.80549 9.65504 9.79154 9.61447C9.77759 9.5739 9.75558 9.53657 9.72682 9.50473C9.69806 9.47289 9.66316 9.4472 9.62421 9.4292C9.58527 9.4112 9.54308 9.40128 9.5002 9.40001C9.42803 9.39885 9.35813 9.42517 9.30465 9.47364C9.25118 9.5221 9.21812 9.58908 9.2122 9.66101C9.205 9.77301 9.201 9.88601 9.2002 10C9.20038 11.1441 9.60922 12.2505 10.353 13.1198C11.0968 13.9891 12.1267 14.5642 13.2569 14.7413C14.3872 14.9185 15.5436 14.6861 16.5177 14.086C17.4918 13.486 18.2196 12.5577 18.5698 11.4685C18.92 10.3794 18.8697 9.20093 18.4278 8.14559C17.986 7.09026 17.1818 6.22743 16.1601 5.71262C15.1383 5.19781 13.9663 5.06488 12.8553 5.33777C11.7442 5.61066 10.7672 6.27144 10.1002 7.20101V6.10001C10.1002 6.02045 10.0686 5.94414 10.0123 5.88788C9.95607 5.83162 9.87976 5.80001 9.8002 5.80001C9.72063 5.80001 9.64432 5.83162 9.58806 5.88788C9.5318 5.94414 9.5002 6.02045 9.5002 6.10001V7.90001C9.5002 7.97958 9.5318 8.05588 9.58806 8.11214C9.64432 8.1684 9.72063 8.20001 9.8002 8.20001H11.6002C11.6798 8.20001 11.7561 8.1684 11.8123 8.11214C11.8686 8.05588 11.9002 7.97958 11.9002 7.90001C11.9002 7.82045 11.8686 7.74414 11.8123 7.68788C11.7561 7.63162 11.6798 7.60001 11.6002 7.60001H10.5532ZM12.8002 8.65061C12.8004 8.54596 12.8279 8.44318 12.8801 8.35247C12.9323 8.26176 13.0073 8.18627 13.0977 8.1335C13.188 8.08074 13.2906 8.05252 13.3953 8.05166C13.4999 8.05081 13.603 8.07733 13.6942 8.12861L16.093 9.47861C16.1856 9.53086 16.2627 9.60678 16.3163 9.69861C16.37 9.79043 16.3982 9.89487 16.3982 10.0012C16.3982 10.1076 16.37 10.212 16.3163 10.3038C16.2627 10.3956 16.1856 10.4716 16.093 10.5238L13.6948 11.8738C13.6036 11.9252 13.5005 11.9519 13.3959 11.9511C13.2912 11.9503 13.1885 11.9222 13.0981 11.8695C13.0076 11.8168 12.9325 11.7413 12.8803 11.6506C12.828 11.5599 12.8004 11.4571 12.8002 11.3524V8.65061ZM15.7984 10.0012L13.4002 8.65121V11.3512L15.7984 10.0012Z",
    fill: "#3D4C5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_680_13617",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_680_13617"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_680_13617",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecPlay);
export default __webpack_public_path__ + "static/media/rec-play.4e71373f8cde1451c1a3cde088e7c5b4.svg";
export { ForwardRef as ReactComponent };